import { Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "keus-ui-google-button",
  imports: [],
  templateUrl: "./ui-google-button.component.html",
  styleUrl: "./ui-google-button.component.css",
})
export class UiGoogleButtonComponent {
  /** Event emitted when the button is clicked. */
  @Output() public readonly clickEvent: EventEmitter<void> =
    new EventEmitter<void>();

  /**
   * Handles the click event.
   */
  public handleClick(): void {
    this.clickEvent.emit();
  }
}
